import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Pager, Tabs, Chip, Person, img, fmt, when } from "./kit";

/// Hediye gecmisi, satin almalar ve sans cantalari — para akisi tek yerde.
const MoneyLogs = () => {
  const [tab, setTab] = useState(() => {
    // panel ozetindeki kutulardan ?tab=purchases ile gelinir
    const t = new URLSearchParams(window.location.search).get("tab");
    return ["gifts", "purchases", "bags"].includes(t) ? t : "gifts";
  });
  const [page, setPage] = useState(1);
  const [q, setQ] = useState("");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const o = { page, size: 25 };
    const res =
      tab === "gifts"
        ? await api.giftLogs(o)
        : tab === "purchases"
        ? await api.purchases({ ...o, q, platform: q === "ios" || q === "android" ? q : undefined })
        : await api.luckyBags(o);
    if (res?.status) setData(res);
    setLoading(false);
  }, [tab, page, q]);

  useEffect(() => {
    load();
  }, [load]);

  const switchTab = (t) => {
    setTab(t);
    setPage(1);
    setData({});
  };

  return (
    <>
      <PageHead title="Para Akışı" sub="Kim kime hediye gönderdi, kim ne satın aldı, hangi şans çantası açıldı." />
      <Tabs
        value={tab}
        onChange={switchTab}
        tabs={[
          ["gifts", "Hediye geçmişi"],
          ["purchases", "Satın almalar"],
          ["bags", "Şans çantaları"],
        ]}
      />

      {tab === "gifts" && (
        <>
          <Tiles
            items={[
              { label: "Toplam hediye işlemi", value: fmt(data.total) },
              { label: "Toplam harcanan coin", value: fmt(data.totalCoin) },
            ]}
          />
          <Table
            loading={loading}
            head={["Gönderen", "Hediye", "Coin", "Alan", "Tarih"]}
            rows={(data.logs || []).map((l) => (
              <tr key={l._id}>
                <td>
                  <Person p={l.sender} />
                </td>
                <td>{l.gift?.image ? <img src={img(l.gift.image)} alt="" style={{ height: 32 }} /> : "—"}</td>
                <td>
                  <b>{fmt(l.coin)}</b>
                </td>
                <td>
                  <Person p={l.receiver} />
                </td>
                <td>{when(l.createdAt)}</td>
              </tr>
            ))}
          />
        </>
      )}

      {tab === "purchases" && (
        <>
          <Tiles
            items={[
              { label: "Doğrulanmış satın alma", value: fmt(data.total) },
              ...(data.totals || []).map((t) => ({ label: `Ciro (${t._id})`, value: fmt(Math.round(t.amount)) })),
              { label: "Satılan coin", value: fmt((data.totals || []).reduce((s, t) => s + t.coin, 0)) },
            ]}
          />
          <input className="form-control" style={{ maxWidth: 320, marginBottom: 12 }} placeholder="İşlem no ara ya da ios / android yaz" value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} />
          <Table
            loading={loading}
            head={["Kullanıcı", "Platform", "Ürün", "Coin", "Tutar", "İşlem no", "Ortam", "Tarih"]}
            empty="Henüz doğrulanmış satın alma yok."
            rows={(data.purchases || []).map((p) => (
              <tr key={p._id}>
                <td>
                  <Person p={p.user} />
                </td>
                <td>{p.platform === "ios" ? "Apple" : "Google"}</td>
                <td style={{ fontSize: 12 }}>{p.productId}</td>
                <td>{fmt(p.coin)}</td>
                <td>
                  {p.amount} {p.currency}
                </td>
                <td style={{ fontSize: 12 }}>
                  <code>{p.transactionId}</code>
                </td>
                <td>{p.environment === "Sandbox" ? <Chip kind="wait">Test</Chip> : <Chip>Gerçek</Chip>}</td>
                <td>{when(p.createdAt)}</td>
              </tr>
            ))}
          />
        </>
      )}

      {tab === "bags" && (
        <Table
          loading={loading}
          head={["Bırakan", "Toplam", "Kişi", "Kalan", "Kapanlar", "Tarih"]}
          rows={(data.bags || []).map((b) => (
            <tr key={b._id}>
              <td>
                <Person image={b.senderImage} name={b.senderName} />
              </td>
              <td>{fmt(b.totalCoin)}</td>
              <td>{b.count}</td>
              <td>
                {b.remainingCount} kişi / {fmt(b.remainingCoin)} coin
              </td>
              <td style={{ fontSize: 12 }}>{(b.grabs || []).map((g) => `${g.userName} (${g.coin})`).join(", ") || "—"}</td>
              <td>{when(b.createdAt)}</td>
            </tr>
          ))}
        />
      )}
      <Pager page={page} size={25} total={data.total || 0} onChange={setPage} />
    </>
  );
};

export default MoneyLogs;
